<template>
  <div>
    <table border="1" cellspacing="0">
      <caption>
        公司安全培训教育、项目部安全培训教育、项目部安全培训教育、模板标题，
        均可自定义模板内容
      </caption>
      <tr class="head">
        <td colspan="4" align="center">
          <input class="title" :disabled="disabled" type="text" v-model="valueBtitle" placeholder="请输入文档标题（三级教育卡）">
        </td>
      </tr>
      <tr>
        <td align="left" colspan="1">
          <div style="padding: 10px">
            <!-- <div>公司安全培训教育内容:</div> -->
            <textarea
              :disabled="disabled"
              v-model="valueB1"
              placeholder="请输入内容"
            ></textarea>
            <div class="footer">
              <div class="jyr">
                教育人：
                <!-- <div
                  :style="{ backgroundImage: 'url(' + valueB1_sign + ')' }"
                  @click="sign(1)"
                  v-if="valueB1_sign"
                ></div>
                <span v-else @click="sign(1)">点击签字</span> -->
              </div>
              <div>受教育人：</div>
              <div>年     月     日</div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td align="left" colspan="1">
          <div style="padding: 10px">
            <!-- <div>项目部安全培训教育内容:</div> -->
            <textarea
              :disabled="disabled"
              v-model="valueB2"
              placeholder="请输入内容"
            ></textarea>
            <div class="footer">
              <div class="jyr">
                教育人：
                <!-- <div
                  :style="{ backgroundImage: 'url(' + valueB2_sign + ')' }"
                  v-if="valueB2_sign"
                  @click="sign(2)"
                ></div>
                <span v-else @click="sign(2)">点击签字</span> -->
              </div>
              <div>受教育人：</div>
              <div>年     月     日</div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td align="left" colspan="1">
          <div style="padding: 10px">
            <!-- <div>班组安全培训教育内容:</div> -->
            <textarea
              :disabled="disabled"
              v-model="valueB3"
              placeholder="请输入内容"
            ></textarea>
            <div class="footer">
              <div class="jyr">
                教育人：
                <!-- <div
                  :style="{ backgroundImage: 'url(' + valueB3_sign + ')' }"
                  @click="sign(3)"
                  v-if="valueB3_sign"
                ></div>
                <span v-else @click="sign(3)">点击签字</span> -->
              </div>
              <div>受教育人：</div>
              <div>年     月     日</div>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <a-modal
      v-model="sign_visible"
      :title="
        sign_type == 1
          ? '公司负责人签字'
          : sign_type == 2
          ? '项目负责人签字'
          : '班组签字'
      "
      @ok="signHandleOk"
      destroyOnClose
      centered
      :keyboard="false"
      :maskClosable="false"
      :confirmLoading="signbtnloading"
      width="auto"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <div class="content">
        <div class="msg" v-if="!sign_img">请签字</div>
        <img v-else :src="sign_img" width="100%" height="100%" alt="" />
      </div>
    </a-modal>
  </div>
</template>
  
  <script>
import SignClient from "@/utils/sign/index";
import { upload } from "@/request/sys";
import { dataURLtoBlob } from "@/utils/os";
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueBtitle: '',//标题
      valueB1: "", //公司安全培训教育内容
      valueB2: "", //项目部安全培训教育内容
      valueB3: "", //班组安全培训教育内容
      valueB1_sign: "", //
      valueB2_sign: "", //
      valueB3_sign: "", //
      Sign: null,
      sign_visible: false,
      sign_type: "",
      sign_img: "",
      signbtnloading: false,
    };
  },
  beforeDestroy() {},
  methods: {
    sign(type) {
      if (type == 1) this.sign_img = this.valueB1_sign;
      if (type == 2) this.sign_img = this.valueB2_sign;
      if (type == 3) this.sign_img = this.valueB3_sign;
      this.sign_type = type;
      this.sign_visible = true;
      if (this.disabled) return;
      this.Sign = new SignClient();
      this.Sign.setInitokCallback(() => {
        this.$message.success("请开始签字");
      });
      this.Sign.setInkCallback((base64) => {
        this.sign_img = base64;
      });
      this.Sign.setErrCallback((res) => {
        this.$error({
          centered: true,
          title: "温馨提示",
          getContainer: ()=> document.getElementById("bodyContnet"),
          content: res.message,
          onOk: () => {
            // this.handleCancel();
          },
        });
      });
      this.Sign.initDevice();
    },
    //base64图片上传服务器返回url地址
    base64Upload(base64, name = "文件名称") {
      return new Promise((resovle, reject) => {
        if (base64.indexOf("http://") > -1 || base64.indexOf("https://") > -1) {
          return resovle({ data: { url: base64 } });
        }
        const file = dataURLtoBlob(base64, encodeURIComponent(name));
        let formData = new FormData();
        formData.append("file", file);
        upload(formData)
          .then((res) => {
            resovle(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    handleCancel() {
      this.sign_visible = false;
      if (this.Sign) {
        this.Sign.close();
        this.Sign = null;
      }
    },
    //保存
    signHandleOk() {
      this.signbtnloading = true;
      this.base64Upload(this.sign_img)
        .then((res) => {
          if (this.sign_type == 1) this.valueB1_sign = res.data.url;
          if (this.sign_type == 2) this.valueB2_sign = res.data.url;
          if (this.sign_type == 3) this.valueB3_sign = res.data.url;
          this.handleCancel();
        })
        .finally(() => {
          this.signbtnloading = false;
        });
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>
  
  <style scoped>
table {
  border-collapse: collapse;
  width: 100%;
  text-align: center;
}
table,
table tr th,
table tr td {
  border: 1px solid #000000;
}
table tr td {
  height: 45px;
}
.head {
  background: #ccc;
  color: #000;
  font-weight: bold;
}
.line4 td {
  width: 25%;
}
textarea {
  border: none;
  width: 100%;
  min-height: 140px;
  outline: none;
  /* margin-top: 10px; */
}
.footer {
  display: flex;
}
.footer div {
  width: 33%;
  text-indent: 10px;
  /* text-align: center; */
}
.jyr {
  position: relative;
  /* border: 1px solid red; */
}
.jyr div {
  position: absolute;
  width: 140px;
  height: 70px;
  left: 30%;
  top: 50%;
  transform: translateY(-50%);
  /* border: 1px solid red; */
  background-position: center;
  background-size: cover;
  cursor: pointer;
}
.jyr span {
  color: #1890ff;
  cursor: pointer;
}
.content {
  width: 387px;
  height: 244px;
  border: 1px solid #f5f6fa;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.msg {
  font-size: 30px;
  line-height: 20px;
  color: #b9d5fd;
}
.title{
  outline: none;
  border: none;
  background: none;
  width: 100%;
  text-align: center;
  font-weight: bold;
  color: #000;
}
</style>